// 5단계 척도 추구미 테스트 문항
// 각 문항은 1-5점으로 채점됩니다
// 1점: 매우 A 스타일 / 2점: 약간 A 스타일 / 3점: 중립 / 4점: 약간 B 스타일 / 5점: 매우 B 스타일

export const CHUGUMI_QUESTIONS = [
    // ========== Part 1: Vibe 축 (8문항) ==========
    // 점수가 높을수록 Masculine에 가깝습니다

    {
        id: 1,
        axis: "vibe",
        reverse: true, // 역채점 문항
        question: "나는 주변 사람들에게 '인상이 부드럽고 편안하다'는 말을 자주 듣는다.",
        question_en: "I am often told that my impression feels soft and comfortable.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 2,
        axis: "vibe",
        reverse: false,
        question: "나는 흐트러진 내추럴한 헤어보다 칼같이 정돈된 스타일을 선호한다.",
        question_en: "I prefer a sharply groomed style over loose, natural hair.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 3,
        axis: "vibe",
        reverse: false,
        question: "나는 대화할 때 감정적인 공감보다는 사실과 논리를 전달하는 것이 더 편하다.",
        question_en: "When talking, I feel more comfortable conveying facts and logic than emotional empathy.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 4,
        axis: "vibe",
        reverse: false,
        question: "나는 포근한 니트 소재보다 빳빳한 셔츠나 가죽 자켓이 더 잘 어울린다고 생각한다.",
        question_en: "I think crisp shirts or leather jackets suit me better than cozy knitwear.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 5,
        axis: "vibe",
        reverse: false,
        question: "나는 귀엽다는 칭찬보다 멋있거나 카리스마 있다는 말을 들을 때 더 기분이 좋다.",
        question_en: "I prefer being called cool or charismatic rather than cute.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 6,
        axis: "vibe",
        reverse: false,
        question: "나는 사진을 찍을 때 따뜻한 햇살 느낌보다 차갑고 대비가 강한 톤을 선호한다.",
        question_en: "For photos, I prefer cool, high-contrast tones over warm sunlight.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 7,
        axis: "vibe",
        reverse: false,
        question: "나는 갈등 상황에서 부드럽게 넘기기보다 확실하게 선을 긋고 해결하는 편이다.",
        question_en: "In conflict, I tend to draw a clear line and resolve it rather than smooth it over.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 8,
        axis: "vibe",
        reverse: false,
        question: "내가 추구하는 아우라는 '친근한 이웃'보다는 '범접하기 힘든 리더'에 가깝다.",
        question_en: "The aura I pursue is closer to an untouchable leader than a friendly neighbor.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },

    // ========== Part 2: Identity 축 (8문항) ==========
    // 점수가 높을수록 Unique에 가깝습니다

    {
        id: 9,
        axis: "identity",
        reverse: true, // 역채점 문항
        question: "나는 쇼핑할 때 디자인이 예뻐도 관리가 힘들거나 불편하면 사지 않는다.",
        question_en: "When shopping, I avoid items that are hard to maintain or uncomfortable even if the design is beautiful.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 10,
        axis: "identity",
        reverse: false,
        question: "나는 남들이 잘 모르는 나만 아는 브랜드를 찾아냈을 때 쾌감을 느낀다.",
        question_en: "I enjoy discovering brands that few other people know.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 11,
        axis: "identity",
        reverse: false,
        question: "나는 유행을 타지 않는 기본 아이템보다는 누가 봐도 시선을 끄는 포인트 아이템을 좋아한다.",
        question_en: "I prefer statement pieces that draw attention over timeless basics.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 12,
        axis: "identity",
        reverse: false,
        question: "나는 검증된 맛집을 가는 것보다 이름 없는 골목의 독특한 가게에 들어가는 걸 즐긴다.",
        question_en: "I enjoy entering a unique, unknown alley restaurant rather than choosing a proven popular place.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 13,
        axis: "identity",
        reverse: false,
        question: "나는 내 소지품들이 내 예술적인 취향을 대변해야 한다고 생각한다.",
        question_en: "I think my belongings should represent my artistic taste.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 14,
        axis: "identity",
        reverse: false,
        question: "나는 SNS에 사진을 올릴 때 평범한 구도보다는 실험적이고 감각적인 구도를 시도한다.",
        question_en: "When posting photos, I try experimental, stylish compositions rather than ordinary ones.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 15,
        axis: "identity",
        reverse: false,
        question: "나는 \"참 단정하시네요\"라는 말보다 \"스타일이 정말 독보적이시네요\"라는 말이 더 좋다.",
        question_en: "I prefer hearing that my style is truly distinctive rather than simply neat.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    },
    {
        id: 16,
        axis: "identity",
        reverse: false,
        question: "나는 물건을 살 때 성능이나 가성비보다 '이것이 주는 영감과 분위기'가 더 중요하다.",
        question_en: "When buying something, its inspiration and mood matter more to me than performance or value.",
        scale: [
            "매우 그렇지 않다",
            "그렇지 않다",
            "보통이다",
            "그렇다",
            "매우 그렇다"
        ],
        scale_en: ["Strongly disagree", "Disagree", "Neutral", "Agree", "Strongly agree"]
    }
];
